import { IClientData, IError } from '.'

export interface IClientDataState {
  data: IClientData
  userId: string
  isLoading: boolean
  error: IError | null
}

export const initialState: IClientDataState = {
  data: {
    name: '',
    document: '',
    phoneNumber: '',
  },
  userId: '',
  isLoading: false,
  error: null,
}
